import { render, staticRenderFns } from "./ItemCourse.vue?vue&type=template&id=1fa77c71&scoped=true"
import script from "./ItemCourse.vue?vue&type=script&lang=js"
export * from "./ItemCourse.vue?vue&type=script&lang=js"
import style0 from "./ItemCourse.vue?vue&type=style&index=0&id=1fa77c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa77c71",
  null
  
)

export default component.exports